import GroupsPicker from './GroupsPicker';
import { Form, Header } from './';
import { formPropTypes } from './common';

import React from 'react';
import { find, map, max, range, orderBy } from 'lodash';
/*
<Form.Field
  control={GroupSelect}
  multiple
  name="groups"
  options={meta.groups.filter(group => !!group.entries.length)}
  value={values.groups}
  onChange={onInputChange}
  label="Groups"
  placeholder="Groups"
  required
  fluid
/>
*/

const SessionForm = ({ formProps, values, onInputChange, meta }) => {
  const currentNumber = Number(values.number);
  const lastNumber = max([1, ...map(meta.sessions, 'number')]);

  const numberOptions = range(
    1,
    lastNumber === currentNumber ? currentNumber + 1 : lastNumber + 2,
  ).map(number => ({
    key: number,
    disabled: number !== currentNumber && !!find(meta.sessions, { number }),
    value: number,
    text: number,
  }));

  const groupsOptions = orderBy(
    meta.groups,
    ['letter', 'order'],
    ['desc', 'asc'],
  ).map(group => ({
    ...group,
    disabled: !!group.session && group.session.number !== currentNumber,
  }));

  return (
    <Form {...formProps}>
      <Form.Group widths="equal">
        <Form.Select
          name="number"
          disabled={values.groups.length > 0}
          value={values.number || ''}
          options={numberOptions}
          onChange={onInputChange}
          label="Number"
          placeholder="Number"
          required
          fluid
        />
        <Form.Input
          name="title"
          value={values.title || ''}
          onChange={onInputChange}
          label="Title"
          placeholder="Title"
          fluid
        />
      </Form.Group>
      <Header>Groups</Header>
      <GroupsPicker
        name="groups"
        value={values.groups || []}
        options={groupsOptions}
        onChange={onInputChange}
        meta={meta}
      />
    </Form>
  );
};

SessionForm.propTypes = formPropTypes;

export default SessionForm;



// WEBPACK FOOTER //
// ./src/components/SessionForm.js